import * as HLF from "html-living-framework";
import * as Constants from "Data/Constants";
import * as Topics from "Data/Topics";
import { Button } from "GameObjects/Button";
import { MusicManager } from "Singletons/MusicManager";
import { TweenMax } from "gsap";

export class MusicGameRecordButton extends Button {

    protected _debugText = this._visuals.addChild(HLF.PixiUtils.makeText("", Constants.FONT_GEL_MED_35, 35));
    protected _recordingIndicator = this._visuals.addChild(new PIXI.Graphics());
    protected _subscriptions: any[] = [];

    constructor() {
        super(()=>this.onClick(), "button-default", Constants.SPRITESHEET_UI);

        this._debugText.text = "Record";

        this._recordingIndicator.beginFill(0xff0000);
        this._recordingIndicator.drawCircle(0, -40, 10);
        this._recordingIndicator.endFill();
        this._recordingIndicator.visible = false;

        TweenMax.fromTo(this._recordingIndicator, 1, {pixi: {alpha: 0}}, {pixi: {alpha: 1}}).yoyo(true).repeat(-1);

        this._subscriptions.push(
            PubSub.subscribe(Topics.RECORDING_COUNT_IN, this.onMessageReceived.bind(this)),
            PubSub.subscribe(Topics.RECORDING_STARTED, this.onMessageReceived.bind(this)),
            PubSub.subscribe(Topics.RECORDING_ENDED, this.onMessageReceived.bind(this)),
            PubSub.subscribe(Topics.PLAYBACK_STARTED, this.onMessageReceived.bind(this)),
        );
    }

    protected onClick() {
        PubSub.publishSync(Topics.REQUEST_START_RECORDING, {});
    }

    protected onMessageReceived(pTopic: string, pData: any) {
        switch (pTopic) {
            case Topics.PLAYBACK_STARTED:
                this.show();
                break;
            case Topics.RECORDING_COUNT_IN:
                this._debugText.text = "Please Wait...";
                break;
            case Topics.RECORDING_STARTED:
                this._debugText.text = "RECORDING";
                this._recordingIndicator.visible = true;
                break;
           case Topics.RECORDING_ENDED:
               this._debugText.text = "Record Again";
               this._recordingIndicator.visible = false;
               break;
        }
    }

}